import { PageReport } from '@grapecity/activereports/core'
import { PdfExport } from '@grapecity/activereports'
import '@grapecity/activereports-localization/dist/designer/ja-locale'
import * as GCAR from '@grapecity/activereports'
import { pdfData } from './requestUtil'

/**
 * 商品受領確認表PDFを出力する関数
 * @param response ヘッダ情報(APIから取得) t
 * @param dataList 明細リスト(Reducerデータ)
 * @returns
 */
export async function exportReport(dataList: pdfData[]): Promise<PdfExport.PdfExportResult> {
  // 定義済みのフォント記述子を登録する
  GCAR.Core.FontStore.registerFonts({ name: 'IPAゴシック', source: 'fonts/ipag.ttf' })
  GCAR.Core.setLicenseKey(process.env.REACT_APP_ARJS_LICENSE as string)
  const reportResponse = await fetch('reports/shohinMeisai.rdlx-json')
  const report = await reportResponse.json()

  report.DataSources[0].ConnectionProperties.ConnectString = 'jsondata=' + JSON.stringify(dataList)
  const pageReport = new PageReport({ language: 'ja' })
  await pageReport.load(report)
  const doc = await pageReport.run()
  return PdfExport.exportDocument(doc, {
    info: {
      title: '納品明細書',
    },
  })
}
